import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from '../environments/environment';
import { LoginComponent } from './pages/login/login.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
	AccordionModule,
	BreadcrumbModule,
	ButtonModule,
	CodeSnippetModule,
	ComboBoxModule,
	ContainedListModule,
	DatePickerModule,
	DialogModule,
	FileUploaderModule,
	IconModule,
	IconService,
	InlineLoadingModule,
	InputModule, LayerModule,
	LoadingModule,
	ModalModule,
	NotificationModule,
	NumberModule,
	PaginationModule,
	SearchModule,
	SelectModule,
	TabsModule,
	TagModule,
	ThemeModule,
	TooltipModule,
	UIShellModule,
} from 'carbon-components-angular';

// Icons
import Notification20 from '@carbon/icons/es/notification/20';
import UserAvatar20 from '@carbon/icons/es/user--avatar/20';
import Filter16 from '@carbon/icons/es/filter/16';
import Launch16 from '@carbon/icons/es/launch/16';
import Edit16 from '@carbon/icons/es/edit/16';
import Restart16 from '@carbon/icons/es/restart/16';
import Checkmark16 from '@carbon/icons/es/checkmark/16';
import CircleDash16 from '@carbon/icons/es/circle-dash/16';
import CheckmarkOutline16 from '@carbon/icons/es/checkmark--outline/16';
import TrashCan16 from '@carbon/icons/es/trash-can/16';
import DocumentExport16 from '@carbon/icons/es/document--export/16';
import DocumentMultiple16 from '@carbon/icons/es/document--multiple-01/16';
import Version16 from '@carbon/icons/es/version/16';
import Folder16 from '@carbon/icons/es/folder/16';
import Delete16 from '@carbon/icons/es/delete/16';
import FolderMoveTo16 from '@carbon/icons/es/folder--move-to/16';
import FolderParent16 from '@carbon/icons/es/folder--parent/16';
import ArrowRight16 from '@carbon/icons/es/arrow--right/16';
import ChooseItem16 from '@carbon/icons/es/choose-item/16';
import Upload16 from '@carbon/icons/es/upload/16';
import CloudUpload16 from '@carbon/icons/es/cloud--upload/16';
import DocumentAdd16 from '@carbon/icons/es/document--add/16';
import FolderAdd16 from '@carbon/icons/es/folder--add/16';
import Login16 from '@carbon/icons/es/login/16';
import DocumentTasks16 from '@carbon/icons/es/document--tasks/16';
import UserAdmin16 from '@carbon/icons/es/user--admin/16';
import ResetAlt16 from '@carbon/icons/es/reset--alt/16';
import Reset16 from '@carbon/icons/es/reset/16';
import ModelBuilderReference16 from '@carbon/icons/es/model-builder/16';
import PartitionCollection16 from '@carbon/icons/es/partition--collection/16';
import DataCollection16 from '@carbon/icons/es/data-collection/16';

// Components
import { MultiplaiComponent } from './multiplai/multiplai.component';
import { NgOptimizedImage } from '@angular/common';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';
import { CreateDealComponent } from './pages/create-deal/create-deal.component';
import { UploadFilesComponent } from './pages/upload-files/upload-files.component';
import { NotificationComponent } from './components/notification/notification.component';
import { DealsComponent } from './pages/deals/deals.component';
import { FilesComponent } from './pages/files/files.component';
import { DeleteDealModalComponent } from './components/delete-deal-modal/delete-deal-modal.component';
import { EditDealModalComponent } from './components/edit-deal-modal/edit-deal-modal.component';
import { DeleteFileModalComponent } from './components/delete-file-modal/delete-file-modal.component';
import { FileDataComponent } from './pages/file-data/file-data.component';
import { FundDataComponent } from './pages/fund-data/fund-data.component';
import { SubmitDealComponent } from './pages/submit-deal/submit-deal.component';
import { SignupComponent } from './pages/signup/signup.component';

@NgModule({
	declarations: [
		AppComponent,
		MultiplaiComponent,
		LoginComponent,
		CreateDealComponent,
		UploadFilesComponent,
  NotificationComponent,
  DealsComponent,
  FilesComponent,
  DeleteDealModalComponent,
  EditDealModalComponent,
  DeleteFileModalComponent,
  FileDataComponent,
  FundDataComponent,
  SubmitDealComponent,
  SignupComponent,
	],
	imports: [
		RouterModule,
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		AppRoutingModule,
		UIShellModule,
		IconModule,
		ThemeModule,
		InputModule,
		ButtonModule,
		FileUploaderModule,
		CodeSnippetModule,
		HttpClientModule,
		ContainedListModule,
		SearchModule,
		DialogModule,
		TooltipModule,
		SelectModule,
		TabsModule,
		NgOptimizedImage,
		ModalModule,
		AngularFireModule.initializeApp(environment.firebaseConfig),
		AngularFireAuthModule,
		AngularFireStorageModule,
		LoadingModule,
		NotificationModule,
		PdfViewerModule,
		InlineLoadingModule,
		TagModule,
		DatePickerModule,
		BreadcrumbModule,
		AccordionModule,
		ComboBoxModule,
		PaginationModule,
		NumberModule,
		LayerModule
	],
	bootstrap: [AppComponent]
})

export class AppModule {
	constructor(protected iconService: IconService) {
		iconService.registerAll([
			Notification20,
			UserAvatar20,
			Filter16,
			Launch16,
			Edit16,
			Restart16,
			Checkmark16,
			CircleDash16,
			CheckmarkOutline16,
			TrashCan16,
			DocumentExport16,
			DocumentMultiple16,
			Version16,
			Folder16,
			Delete16,
			FolderMoveTo16,
			FolderParent16,
			ArrowRight16,
			ChooseItem16,
			Upload16,
			CloudUpload16,
			DocumentAdd16,
			FolderAdd16,
			Login16,
			DocumentTasks16,
			UserAdmin16,
			ResetAlt16,
			Reset16,
			ModelBuilderReference16,
			PartitionCollection16,
			DataCollection16
		]);
	}
}
